import { Box, Typography } from '@mui/material';

export const AvanzuHeader: React.FC<{}> = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <img
        src="/avanzu-logo.png"
        alt="Avanzu Logo"
        style={{
          height: '20px',
          width: 'auto',
        }}
      />
      <Typography
        variant="h2"
        noWrap
        component="div"
        sx={{
          color: 'primary.main',
          fontWeight: 700,
          letterSpacing: '-0.5px',
          textShadow: '0 2px 4px rgba(79, 70, 229, 0.1)',
        }}
      >
        Avanzu
      </Typography>
    </Box>
  );
};
export default AvanzuHeader;
